import { useFetch } from './fetch';
import { FilterResponse } from './types/filters';

export const useFilters = () => {
  const { isLoading, serverError, apiData } = useFetch(
    'GET',
    `${process.env.REACT_APP_BACKEND_API_URL}/rcm/filters`,
    {},
  );
  return {
    isLoading,
    filters: apiData as unknown as FilterResponse,
    serverError,
  };
};
